/* eslint-disable @typescript-eslint/camelcase */
var Popover = require('../widgets/popover'),
  plate = require('@ua/plate'),
  is_listening = false,
  open_options = {}

var template = (template = new plate.Template(
  '<div class="help-text"><span class="arrow up">' +
    '</span>{{ help_text }}</div>'
))

var popover

$(document).ready(() => {
  popover = new Popover(template, 'popover tooltip')
  $('body')
    .on('mouseenter', '[data-help]', show_tooltip)
    .on('mouseleave', '[data-help]', hide_tooltip)
    .on('click', '[data-help]', function(ev) {
      hide_tooltip()
      if (ev.currentTarget.getAttribute('href') === '#') {
        ev.preventDefault()
      }
    })
})

function show_tooltip(ev) {
  // make sure our element is always last.
  popover.el.appendTo('body')

  var el = $(ev.currentTarget),
    text = el.attr('data-help')

  open_options.context = {help_text: text}

  popover.open(el, open_options)

  is_listening = true
}

function hide_tooltip() {
  if (!is_listening) {
    return
  }

  is_listening = false

  popover.hide()
}
